var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { FormatSettingsFactory } from "./FormatSettingsFactory";
import { CustomSourceReferenceFactory } from "./CustomSourceReferenceFactory";
import { CustomSourceConfigurationFactory } from "./CustomSourceConfigurationFactory";
export class TemplateConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "AvailableTemplates");
    /**
     */
    __publicField(this, "CustomSourceConfiguration");
    /**
     */
    __publicField(this, "FormatSettings");
    /**
     */
    __publicField(this, "SalePurchaseSeparately");
    /**
     */
    __publicField(this, "TemplateFileReference");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TemplateConfiguration
     */
    __publicField(this, "$type", "V1.GenerationConfiguration.TemplateConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["AvailableTemplates"] && _data["AvailableTemplates"].constructor === Array) {
        this.AvailableTemplates = [];
        for (let item of _data["AvailableTemplates"]) {
          this.AvailableTemplates.push(TemplateConfigurationAvailableTemplates[item]);
        }
      }
      const $typeCustomSourceConfiguration = _data["CustomSourceConfiguration"] && _data["CustomSourceConfiguration"].$type;
      if ($typeCustomSourceConfiguration) {
        const customSourceConfiguration_ = CustomSourceConfigurationFactory.create($typeCustomSourceConfiguration);
        this.CustomSourceConfiguration = customSourceConfiguration_.init(_data["CustomSourceConfiguration"]);
      } else {
        this.CustomSourceConfiguration = _data["CustomSourceConfiguration"];
      }
      const $typeFormatSettings = _data["FormatSettings"] && _data["FormatSettings"].$type;
      if ($typeFormatSettings) {
        const formatSettings_ = FormatSettingsFactory.create($typeFormatSettings);
        this.FormatSettings = formatSettings_.init(_data["FormatSettings"]);
      } else {
        this.FormatSettings = _data["FormatSettings"];
      }
      this.SalePurchaseSeparately = _data["SalePurchaseSeparately"];
      const $typeTemplateFileReference = _data["TemplateFileReference"] && _data["TemplateFileReference"].$type;
      if ($typeTemplateFileReference) {
        const templateFileReference_ = CustomSourceReferenceFactory.create($typeTemplateFileReference);
        this.TemplateFileReference = templateFileReference_.init(_data["TemplateFileReference"]);
      } else {
        this.TemplateFileReference = _data["TemplateFileReference"];
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.AvailableTemplates && this.AvailableTemplates.constructor === Array) {
      _data["AvailableTemplates"] = [];
      for (let item of this.AvailableTemplates) {
        _data["AvailableTemplates"].push(TemplateConfigurationAvailableTemplates[item]);
      }
    }
    _data["CustomSourceConfiguration"] = this.CustomSourceConfiguration ? this.CustomSourceConfiguration.toJSON() : void 0;
    _data["FormatSettings"] = this.FormatSettings ? this.FormatSettings.toJSON() : void 0;
    _data["SalePurchaseSeparately"] = this.SalePurchaseSeparately;
    _data["TemplateFileReference"] = this.TemplateFileReference ? this.TemplateFileReference.toJSON() : void 0;
    return _data;
  }
}
export var TemplateConfigurationAvailableTemplates = /* @__PURE__ */ ((TemplateConfigurationAvailableTemplates2) => {
  TemplateConfigurationAvailableTemplates2["Amazon"] = "Amazon";
  TemplateConfigurationAvailableTemplates2["Mp"] = "Mp";
  TemplateConfigurationAvailableTemplates2["Csv"] = "Csv";
  TemplateConfigurationAvailableTemplates2["Dsv"] = "Dsv";
  TemplateConfigurationAvailableTemplates2["Excel"] = "Excel";
  TemplateConfigurationAvailableTemplates2["SAPText"] = "SAPText";
  return TemplateConfigurationAvailableTemplates2;
})(TemplateConfigurationAvailableTemplates || {});
